<template>
  <v-card class="mt-4">
    <v-card-title class="text-h6 font-weight-bold pa-3"
      ><v-icon color="primary" left>mdi-thumbs-up-down-outline</v-icon>Serviços
      Aguardando Aprovação
    </v-card-title>

    <v-card-text class="pa-6">
      <v-data-table
        :headers="headers"
        :items="atividades"
        :items-per-page="8"
        disable-sort
        class="data-tables data-tables__row-click"
        @click:row="editarAtividade"
      >
        <template v-slot:item.titulo="{ item }">
          {{ item.titulo | excerpt(30) }}
        </template>

        <template v-slot:item.cliente_nome="{ item }">
          {{ item.cliente_nome | excerpt(15) }}
        </template>
        <template v-slot:item.inicio="{ item }">
          {{ item.inicio | dateFormat("dd/MM/yyyy") }}
        </template>
        <template v-slot:item.entrega="{ item }">
          {{ item.entrega | dateFormat("dd/MM/yyyy") }}
        </template>
        <template v-slot:item.status="{ item }">
          {{ item.status === 5 ? "CLIENTE" : "GESTOR" }}
        </template>
      </v-data-table>
    </v-card-text>
    <AtividadesEditarTrabalho
      v-if="dialogEditAtividade"
      :dialogEditAtividade.sync="dialogEditAtividade"
      :atividadeSelected="atividadeSelected"
      :cliente_id="cliente_id"
      :component_dashboard="true"
      @fetch-servicos="getAtividadesAguardandoAprovacao"
    />
  </v-card>
</template>

<script>
import { fetchAtividadesAguardandoAprovacao } from "@/api/gestor/dashboard/atividades.js";
export default {
  name: "BoxAtividadesEmAndamento",

  data() {
    return {
      atividades: [],
      loading: false,
      dialogEditAtividade: false,
      atividadeSelected: null,
      cliente_id: null,
    };
  },

  components: {
    AtividadesEditarTrabalho: () =>
      import("@/views/gestor/atividades/AtividadesEditarTrabalho.vue"),
  },

  computed: {
    headers() {
      return [
        {
          text: "Título",
          value: "titulo",
        },

        {
          text: "Cliente",
          value: "cliente_nome",
        },
        {
          text: "Serviço",
          value: "servico_descricao",
        },
        {
          text: "Início",
          value: "inicio",
        },
        {
          text: "Entrega",
          value: "entrega",
        },
        {
          text: "Aguardando Aprovação",
          width: "54px",
          value: "status",
        },
      ];
    },
  },

  methods: {
    getAtividadesAguardandoAprovacao() {
      this.loading = true;
      return fetchAtividadesAguardandoAprovacao()
        .then((response) => {
          this.atividades = response;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    editarAtividade(item) {
      this.atividadeSelected = item.id;
      this.cliente_id = item.cliente_id;
      this.dialogEditAtividade = true;
    },
  },

  mounted() {
    this.getAtividadesAguardandoAprovacao();
  },
};
</script>

<style></style>
